import { useCallback } from 'react';

import { useRandom } from './useRandom';

/**
 * Given a desired item count, return a function that takes an array and returns
 * a random sampling of that array up to the desired item count.
 */
export const useRandomSample = (count?: number) => {
  const random = useRandom();

  return useCallback(
    <T>(array: T[]): T[] => {
      const shuffled = [...array];

      let currentIndex = shuffled.length;
      let randomIndex;

      // Fisher-Yates shuffle algorithm
      while (currentIndex > 0) {
        randomIndex = Math.floor(random() * currentIndex);
        currentIndex -= 1;

        [shuffled[currentIndex], shuffled[randomIndex]] = [
          shuffled[randomIndex],
          shuffled[currentIndex],
        ];
      }

      return shuffled.slice(
        0,
        typeof count === 'undefined'
          ? array.length
          : Math.min(count, array.length),
      );
    },
    [count, random],
  );
};
